__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@primer-io/checkout-web";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@primer-io/shared-library/components", "2.6.3", function() { return function() { return __webpack_require__(69138); }; }, 1);
			register("@primer-io/shared-library/contexts", "2.6.3", function() { return function() { return __webpack_require__(51796); }; }, 1);
			register("@primer-io/shared-library/payment-method-utils", "2.6.3", function() { return function() { return __webpack_require__(39902); }; }, 1);
			register("immer", "9.0.12", function() { return function() { return __webpack_require__(15729); }; }, 1);
			register("preact/compat", "4.0.0", function() { return function() { return __webpack_require__(66741); }; }, 1);
			register("preact/hooks", "0.1.0", function() { return function() { return __webpack_require__(34619); }; }, 1);
			register("preact", "10.5.12", function() { return function() { return __webpack_require__(33847); }; }, 1);
			register("styled-components", "5.3.3", function() { return function() { return __webpack_require__(52275); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};